import CaretIconSmall from './component.jsx'
export default CaretIconSmall
